// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-557969f8] .el-dialog{width:870px}.dialog-body[data-v-557969f8],.dialog-body .textDescribe[data-v-557969f8]{width:100%}.dialog-body .textDescribe p[data-v-557969f8]{margin:0}.dialog-body .partnerBox[data-v-557969f8]{width:100%;padding:15px 0 10px 0}.dialog-body .partnerBox .optionsTitle[data-v-557969f8]{width:100%}.dialog-body .partnerBox .optionsContent-two[data-v-557969f8]{width:100%;margin:20px 0 0 0}", ""]);
// Exports
module.exports = exports;
